import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../../../store';
import { getSayHelloFormAllCoursesAPIRequest } from './SayHelloFormAllCoursesAPI';

export interface Course {
  id: number;
  name: string;
}

interface CourseState {
  sayHelloFormCourses: Course[];
  fetchSayHelloFormCoursesLoading: boolean;
  fetchSayHelloFormCourseStatus: 'IDLE' | 'PENDING' | 'SUCCESS' | 'FAILED';
}

const initialState: CourseState = {
  sayHelloFormCourses: [],
  fetchSayHelloFormCourseStatus: 'IDLE',
  fetchSayHelloFormCoursesLoading: true,
};

export const fetchSayHelloFormAllCoursesRequest = createAsyncThunk(
  'get/say-hello-form/courses',
  async (domain: string) => {
    try {
      const response = await getSayHelloFormAllCoursesAPIRequest(domain);
      return response;
    } catch (error) {
      throw new Error('Failed to fetch course data');
    }
  }
);

const fetchSayHelloFormAllCoursesSlice = createSlice({
  name: 'fetchSayHelloFormCourses',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSayHelloFormAllCoursesRequest.pending, (state, action) => {
        state.fetchSayHelloFormCoursesLoading = true;
        state.fetchSayHelloFormCourseStatus = 'PENDING';
      })
      .addCase(fetchSayHelloFormAllCoursesRequest.fulfilled, (state, action) => {
        state.sayHelloFormCourses = action.payload;
        state.fetchSayHelloFormCoursesLoading = false;
        state.fetchSayHelloFormCourseStatus = 'SUCCESS';
      })
      .addCase(fetchSayHelloFormAllCoursesRequest.rejected, (state, action) => {
        state.fetchSayHelloFormCoursesLoading = false;
        state.fetchSayHelloFormCourseStatus = 'FAILED';
      });
  },
});

export const fetchSayHelloFormAllCoursesSelector = (state: RootState) => state.getSayHelloFormAllCourses;
export default fetchSayHelloFormAllCoursesSlice.reducer;
